import React from 'react';
import Hero from '../components/Hero';
import TechStack from '../components/TechStack';

const Home = () => {
  return (
    <>
      <Hero />
      <TechStack />
    </>
  );
};

export default Home;
